export default __webpack_public_path__ + "static/media/keys-small-team.dba783ab.svg";